module.exports = __webpack_public_path__ + "static/media/book_armaghan_ae_hijaz_persian_11.4cbb4fad.jpg";